import http from '@/biz/http.mjs'

export default {
    pull: ({pkid}) => http.get(`/brf/loadDp`, {pkid}).then(res => ({ ...res, stsCode: 'DRAFT' })),
    push: (data) => http.post('/brf/modifyDp', data),
    read: ({pkid}) => http.get(`/brf/oneBrfLatestMap`, {pkid}).then(res => ({ ...res, stsCode: 'DRAFT' })),
    update: (data) => http.post(`/brf/saveMap`, data),
}
